export async function postApiCall(endpoint, body = null, token = null) {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const url = new URL(`${baseUrl}${endpoint}`);

  const settings = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : null,
  };

  const response = await fetch(url, settings);
  const data = await response.json();
  return data;
}
